import { useKeycloak } from "@react-keycloak/web";
import { Table } from 'reactstrap';
import PrevPovrch from './PrevPovrch';

function ListingPovrchu(props: any) {
    const { keycloak, initialized } = useKeycloak();
    /*
    console.log("<ListingPovrchu debug of vars")
    console.log("props")
    console.log(props)
    console.log("-END-")
    */
    return (<Table striped hover size="sm">
            <thead>
                <tr>
                    <th>KÓD</th>
                    <th>NÁZEV</th>
                    <th>VZOREK</th>
                    <th>POUŽITÍ</th>
                    <th>PODMÍNKA</th>
                    <th>POPIS</th>
                    <th>VÝŠKA</th>{/*vyska naslapne vrstvy*/}
                    <th>UPRAVENO</th>
                    {keycloak.authenticated && (<th>VIDITITELNOST</th>)}
                </tr>
            </thead>
            <tbody>
                {(props.povrchy.length!==0) ?
                props.povrchy.map((povrch: any) => <PrevPovrch key={povrch.id} povrch={povrch} />):
                <tr><td>ZADNE VYSLEDKY NA ZAKLADE FILTROVANI</td></tr>}
            </tbody>
        </Table>)
}
export default ListingPovrchu